function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#3B086B"
    },
    d: "M104.9,81H48.5c-3-0.3-5.3-3-5.1-6c-0.3-3.1,2-5.9,5.1-6.2h56.4 c3.1,0.3,5.4,3.1,5.1,6.2C110.2,78,107.9,80.7,104.9,81z M145.9,113.4H48.5c-3.5-0.7-5.7-4.1-5-7.5c0.5-2.5,2.5-4.5,5-5h97.4 c3.5,0.7,5.7,4.1,5,7.5C150.4,110.9,148.4,112.9,145.9,113.4z M145.9,145.8H48.5c-3.5-0.7-5.7-4.1-5-7.5c0.5-2.5,2.5-4.5,5-5h97.4 c3.5,0.7,5.7,4.1,5,7.5C150.4,143.3,148.4,145.2,145.9,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M48.8,143.6c-2.2-0.5-3.6-2.7-3.1-5c0.3-1.6,1.5-2.9,3.1-3.3h96.9c1,0.3,1.9,0.9,2.5,1.8 c0.6,0.9,0.9,2.1,0.6,3.2c-0.3,1.6-1.5,2.9-3.1,3.3H48.8z M48.8,111.2c-2.2-0.5-3.6-2.7-3.1-5c0.3-1.6,1.5-2.9,3.1-3.3h96.9 c1,0.3,1.9,0.9,2.5,1.8c0.6,0.9,0.9,2.1,0.6,3.2c-0.3,1.6-1.5,2.9-3.1,3.3H48.8z M48.7,78.9c-1.9-0.3-3.2-1.9-3.1-3.8l0-0.2l0-0.2 c-0.2-1.9,1.2-3.7,3.1-3.9h56.1c1.9,0.3,3.3,2,3.1,3.9l0,0.2l0,0.2c0.1,1.9-1.3,3.5-3.1,3.8H48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#3B086B"
    },
    d: "M37.7,0c-13.8,0-25,11.2-25,25v150c0,13.8,11.2,25,25,25h125c13.8,0,25-11.2,25-25 L189,44L146.3,0C146.3,0,37.7,0,37.7,0z M137.7,12.5L175.2,50h-31.4c-3.4,0-6.1-2.7-6.1-6.1V12.5z M162.7,187.5h-125 c-6.9,0-12.5-5.6-12.5-12.5V25c0-6.9,5.6-12.5,12.5-12.5h87.5V50c0,6.9,5.6,12.5,12.5,12.5h37.5V175 C175.2,181.9,169.6,187.5,162.7,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M37.7,197.9c-12.6,0-22.9-10.3-22.9-22.9V25C14.8,12.4,25,2.1,37.7,2.1h100.9l48.3,47.6L185.5,175 c0,12.6-10.3,22.9-22.9,22.9H37.7z M37.7,10.4C29.6,10.4,23,16.9,23,25v150c0,8.1,6.6,14.6,14.6,14.6h125c8.1,0,14.6-6.6,14.6-14.6 V60.4h-39.6c-5.7,0-10.4-4.7-10.4-10.4V10.4H37.7z M135.5,44.4c0,4.2,3.5,7.7,7.7,7.7h34.1l-41.8-41.8V44.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6fe6613dc86272691526f4fdcb9608e9.svg";
export { ForwardRef as ReactComponent };